module.exports = __webpack_public_path__ + "img/ac-logo-full-white.8615d7d6.png";